<div fxLayout="column" fxLayoutGap="10px" [formGroup]="grp">

  <div fxLayout="row" fxLayoutGap="10px">

    <mat-form-field fxFlex="120px">
      <mat-label>Period type</mat-label>
      <mat-select placeholder="" formControlName="isCurrent">
        <mat-option [value]="true">Current</mat-option>
        <mat-option [value]="false">Last</mat-option>
      </mat-select>
      <mat-error>Required field</mat-error>
    </mat-form-field>

    @if (!grp.value.isCurrent) {
      <app-time-period-select fxFlex="120px" [formControl]="grp.controls.last" multiplyLabel="Many"></app-time-period-select>
    }

    @if (grp.value.isCurrent) {
      <mat-form-field fxFlex="120px">
        <mat-label>Time unit</mat-label>
        <mat-select placeholder="" formControlName="current" (selectionChange)="notifyFormChanged()">
          <mat-option [value]="TimePeriodUnit.Day">Day</mat-option>
          <mat-option [value]="TimePeriodUnit.Month">Month</mat-option>
          <mat-option [value]="TimePeriodUnit.Year">Year</mat-option>
        </mat-select>
        <mat-error>Required field</mat-error>
      </mat-form-field>
    }

  </div>

  <!--<pre>{{ form.value | json }}</pre>-->
</div>